import {GraphThingyView} from '../view/view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI} from '../thunk/tunc';
import { color } from '../../utility/mycolorfunc';

interface OwnProps {
    id:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
       //data:state.vuln_summary_graph.config.data,
       config:{
           ...state.vuln_summary_graph.config,
           color:color,
       },
       view:state.vuln_summary_graph.view
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
    }
}


const VulnerabilitySummaryGraphContainer=connect(mapStateToProps, bindDispatchToActions)(GraphThingyView);
export default VulnerabilitySummaryGraphContainer;